import { ACTIONS_SCHEDULED_JOB } from '../_constants/scheduledJob.constants';

const initialState = {
  byId: {},
};

export function scheduledJobReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_SCHEDULED_JOB.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_SCHEDULED_JOB.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_SCHEDULED_JOB.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default scheduledJobReducer;
